import React, { useEffect, useRef } from 'react';
import './Collaborations.css';

const collaborationItems = [
  {
    title: 'Partners',
    description: 'We collaborate with innovative startups and tech leaders to bring the best solutions to our clients.',
    icon: '🤝',
  },
  {
    title: 'Early Adopters',
    description: 'Our early adopters are key to refining our products and shaping the future of Neelaverse Technologies.',
    icon: '🚀',
  },
  {
    title: 'Community Support',
    description: 'Engaging with our vibrant tech community helps us stay ahead and create meaningful impact together.',
    icon: '🌐',
  },
];

function Collaborations() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let width = canvas.width = window.innerWidth;
    let height = canvas.height = window.innerHeight;

    const dots = [];
    const dotCount = 50;
    const maxDistance = 150;

    class Dot {
      constructor() {
        this.x = Math.random() * width;
        this.y = Math.random() * height;
        this.vx = (Math.random() - 0.5) * 0.5;
        this.vy = (Math.random() - 0.5) * 0.5;
        this.radius = 2.5;
      }

      move() {
        this.x += this.vx;
        this.y += this.vy;

        if (this.x < 0 || this.x > width) this.vx *= -1;
        if (this.y < 0 || this.y > height) this.vy *= -1;
      }

      draw() {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        ctx.fillStyle = '#00fff7';
        ctx.shadowBlur = 8;
        ctx.shadowColor = '#00fff7';
        ctx.fill();
      }
    }

    for (let i = 0; i < dotCount; i++) {
      dots.push(new Dot());
    }

    function connectDots() {
      for (let i = 0; i < dots.length; i++) {
        for (let j = i + 1; j < dots.length; j++) {
          const dx = dots[i].x - dots[j].x;
          const dy = dots[i].y - dots[j].y;
          const dist = Math.sqrt(dx * dx + dy * dy);

          if (dist < maxDistance) {
            ctx.beginPath();
            ctx.moveTo(dots[i].x, dots[i].y);
            ctx.lineTo(dots[j].x, dots[j].y);
            ctx.strokeStyle = `rgba(0, 255, 247, ${(1 - dist / maxDistance).toFixed(2)})`;
            ctx.lineWidth = 0.8;
            ctx.stroke();
            ctx.closePath();
          }
        }
      }
    }

    function animate() {
      ctx.clearRect(0, 0, width, height);
      dots.forEach(dot => {
        dot.move();
        dot.draw();
      });
      connectDots();
      requestAnimationFrame(animate);
    }

    animate();

    function handleResize() {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="collaborations-page">
      <canvas ref={canvasRef} className="collab-canvas" />
      <div className="collab-cards">
        {collaborationItems.map(({ title, description, icon }, idx) => (
          <div key={idx} className="collab-card" tabIndex={0} role="button" aria-pressed="false">
            <div className="collab-icon">{icon}</div>
            <h2 className="collab-title">{title}</h2>
            <p className="collab-description">{description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Collaborations;
